/* Copyright (c) 2021 Caring Transitions Online Auctions. All Rights Reserved. */

import React from "react";
import { Row, Col, Container, Button } from 'react-bootstrap';
import './HelpSidebar.scss';

/** 

@Author Karthik

@param

@return Help side bar html

**/


export class HelpSideBar extends React.Component {

    constructor(props) {
        super(props);

        this.initialHelp = {
            display_name: 'help',
            id: 'help'
        }

        this.state = {
            help: this.props.props ? this.props.props : this.initialHelp,
            active_tag: this.props.props ? this.props.props.id : 'help'
        }
    }

    componentDidMount() {
        this.executeScroll();
    }
    // componentDidUpdate() {
    //     this.executeScroll();
    // }

    executeScroll = () => {
        this[`${this.state.help.id}`] ? this.finalSettingToDiv() : this.emptyFun();
    };

    emptyFun = () => { }

    finalSettingToDiv = () => {
        this[`${this.state.help.id}`].scrollIntoView();
    }

    selectContent = (flag) => {
        this.setState({
            active_tag: flag
        });
    }

    onCloseEvent = () => {
        this.props.onClose('Closing');
    }

    render() {
        return (
            <div className={`help-side-bar`}>
                <div className={`header`}>
                    <Container>
                        <Row>
                            <Col sm="10" className={`text-secondary text-bold`}>
                                <img src={`${process.env.PUBLIC_URL}/static/icons/table/help.svg`} alt="help-image" width="20px"></img> Help
                            </Col>
                            <Col sm="2">
                                <span className={`close-icon clickable`} onClick={this.onCloseEvent}></span>
                            </Col>
                        </Row>
                    </Container>
                </div>
                <div className={'help-body'}>

                    <div className={'help-content'}>
                        <div ref={(el) => this[`location_email`] = el} className={`${this.state.active_tag === 'location_email' ? 'active-tag' : ''}`}>
                            <div className="content-box">
                                <div className="title" onClick={() => this.selectContent('location_email')}>
                                    <div className="required">Location Email</div>
                                    <div>
                                        <i className={`fa ${this.state.active_tag === 'location_email' ? 'fa-chevron-down' : 'fa-chevron-right'}`}></i>
                                    </div>
                                </div>
                                <div className="expand">
                                    <h5>Location Email</h5>
                                    <div>Contact phone number is for reach who handles the sale.</div>
                                </div>
                            </div>
                        </div>
                        <div ref={(el) => this[`location_phone`] = el} className={`${this.state.active_tag === 'location_phone' ? 'active-tag' : ''}`}>
                            <div className="content-box">
                                <div className="title" onClick={() => this.selectContent('location_phone')}>
                                    <div className="required">Location Phone</div>
                                    <div>
                                        <i className={`fa ${this.state.active_tag === 'location_phone' ? 'fa-chevron-down' : 'fa-chevron-right'}`}></i>
                                    </div>
                                </div>
                                <div className="expand">
                                    <h5>Location Phone</h5>
                                    <div>Contact phone number is for reach who handles the sale.</div>
                                </div>
                            </div>
                        </div>
                        <div ref={(el) => this[`external_website`] = el} className={`${this.state.active_tag === 'external_website' ? 'active-tag' : ''}`}>
                            <div className="content-box">
                                <div className="title" onClick={() => this.selectContent('external_website')}>
                                    <div>External Website</div>
                                    <div>
                                        <i className={`fa ${this.state.active_tag === 'external_website' ? 'fa-chevron-down' : 'fa-chevron-right'}`}></i>
                                    </div>
                                </div>
                                <div className="expand">
                                    <h5>External Website</h5>
                                    <div>Contact phone number is for reach who handles the sale.</div>
                                </div>
                            </div>
                        </div>
                        <div ref={(el) => this[`time_zone`] = el} className={`${this.state.active_tag === 'time_zone' ? 'active-tag' : ''}`}>
                            <div className="content-box">
                                <div className="title" onClick={() => this.selectContent('time_zone')}>
                                    <div className="required">Time Zone</div>
                                    <div>
                                        <i className={`fa ${this.state.active_tag === 'time_zone' ? 'fa-chevron-down' : 'fa-chevron-right'}`}></i>
                                    </div>
                                </div>
                                <div className="expand">
                                    <h5>Time Zone</h5>
                                    <div>Contact phone number is for reach who handles the sale.</div>
                                </div>
                            </div>
                        </div>
                        <div ref={(el) => this[`payPal_email`] = el} className={`${this.state.active_tag === 'payPal_email' ? 'active-tag' : ''}`}>
                            <div className="content-box">
                                <div className="title" onClick={() => this.selectContent('payPal_email')}>
                                    <div className="required">PayPal Email</div>
                                    <div>
                                        <i className={`fa ${this.state.active_tag === 'payPal_email' ? 'fa-chevron-down' : 'fa-chevron-right'}`}></i>
                                    </div>
                                </div>
                                <div className="expand">
                                    <h5>PayPal Email</h5>
                                    <div>Contact phone number is for reach who handles the sale.</div>
                                </div>
                            </div>
                        </div>
                        <div ref={(el) => this[`google_code`] = el} className={`${this.state.active_tag === 'google_code' ? 'active-tag' : ''}`}>
                            <div className="content-box">
                                <div className="title" onClick={() => this.selectContent('google_code')}>
                                    <div>Google Code</div>
                                    <div>
                                        <i className={`fa ${this.state.active_tag === 'google_code' ? 'fa-chevron-down' : 'fa-chevron-right'}`}></i>
                                    </div>
                                </div>
                                <div className="expand">
                                    <h5>Google Code</h5>
                                    <div>Contact phone number is for reach who handles the sale.</div>
                                </div>
                            </div>
                        </div>
                        <div ref={(el) => this[`fb_pixel`] = el} className={`${this.state.active_tag === 'fb_pixel' ? 'active-tag' : ''}`}>
                            <div className="content-box">
                                <div className="title" onClick={() => this.selectContent('fb_pixel')}>
                                    <div>FB Pixel</div>
                                    <div>
                                        <i className={`fa ${this.state.active_tag === 'fb_pixel' ? 'fa-chevron-down' : 'fa-chevron-right'}`}></i>
                                    </div>
                                </div>
                                <div className="expand">
                                    <h5>FB Pixel</h5>
                                    <div>Contact phone number is for reach who handles the sale.</div>
                                </div>
                            </div>
                        </div>
                        <div ref={(el) => this[`role`] = el} className={`${this.state.active_tag === 'role' ? 'active-tag' : ''}`}>
                            <div className="content-box">
                                <div className="title" onClick={() => this.selectContent('role')}>
                                    <div className="required">Role</div>
                                    <div>
                                        <i className={`fa ${this.state.active_tag === 'role' ? 'fa-chevron-down' : 'fa-chevron-right'}`}></i>
                                    </div>
                                </div>
                                <div className="expand">
                                    <h5>Role</h5>
                                    <div>Contact phone number is for reach who handles the sale.</div>
                                </div>
                            </div>
                        </div>
                        <div ref={(el) => this[`staff_and_agent_status`] = el} className={`${this.state.active_tag === 'staff_and_agent_status' ? 'active-tag' : ''}`}>
                            <div className="content-box">
                                <div className="title" onClick={() => this.selectContent('staff_and_agent_status')}>
                                    <div className="required">Status</div>
                                    <div>
                                        <i className={`fa ${this.state.active_tag === 'staff_and_agent_status' ? 'fa-chevron-down' : 'fa-chevron-right'}`}></i>
                                    </div>
                                </div>
                                <div className="expand">
                                    <h5>Status</h5>
                                    <div>Contact phone number is for reach who handles the sale.</div>
                                </div>
                            </div>
                        </div>
                        <div ref={(el) => this[`contact_number_for_sale`] = el} className={`${this.state.active_tag === 'contact_number_for_sale' ? 'active-tag' : ''}`}>
                            <div className="content-box">
                                <div className="title" onClick={() => this.selectContent('contact_number_for_sale')}>
                                    <div className="required">Contact phone number</div>
                                    <div>
                                        <i className={`fa ${this.state.active_tag === 'contact_number_for_sale' ? 'fa-chevron-down' : 'fa-chevron-right'}`}></i>
                                    </div>
                                </div>
                                <div className="expand">
                                    <h5>Contact phone number</h5>
                                    <div>Contact phone number is for reach who handles the sale.</div>
                                </div>
                            </div>
                        </div>
                        <div ref={(el) => this[`contact_email_for_sale`] = el} className={`${this.state.active_tag === 'contact_email_for_sale' ? 'active-tag' : ''}`}>
                            <div className="content-box">
                                <div className="title" onClick={() => this.selectContent('contact_email_for_sale')}>
                                    <div className="required">Contact email</div>
                                    <div>
                                        <i className={`fa ${this.state.active_tag === 'contact_email_for_sale' ? 'fa-chevron-down' : 'fa-chevron-right'}`}></i>
                                    </div>
                                </div>
                                <div className="expand">
                                    <h5>Contact email</h5>
                                    <div>Update will send to this email.</div>
                                </div>
                            </div>
                        </div>
                        <div ref={(el) => this[`contact_name_for_sale`] = el} className={`${this.state.active_tag === 'contact_name_for_sale' ? 'active-tag' : ''}`}>
                            <div className="content-box">
                                <div className="title" onClick={() => this.selectContent('contact_name_for_sale')}>
                                    <div className="required">Contact Name</div>
                                    <div>
                                        <i className={`fa ${this.state.active_tag === 'contact_name_for_sale' ? 'fa-chevron-down' : 'fa-chevron-right'}`}></i>
                                    </div>
                                </div>
                                <div className="expand">
                                    <h5>Contact Name</h5>
                                    <div>Contact Name is the name of the contact who handles the sale for a location.</div>
                                </div>
                            </div>
                        </div>
                        <div ref={(el) => this[`sale_title`] = el} className={`${this.state.active_tag === 'sale_title' ? 'active-tag' : ''}`}>
                            <div className="content-box">
                                <div className="title" onClick={() => this.selectContent('sale_title')}>
                                    <div className="required">Sale title</div>
                                    <div>
                                        <i className={`fa ${this.state.active_tag === 'sale_title' ? 'fa-chevron-down' : 'fa-chevron-right'}`}></i>
                                    </div>
                                </div>
                                <div className="expand">
                                    <h5>Sale title</h5>
                                    <div>Sale title is just for idenify which type of sale this.</div>
                                </div>
                            </div>
                        </div>
                        <div ref={(el) => this[`sale_address_1`] = el} className={`${this.state.active_tag === 'sale_address_1' ? 'active-tag' : ''}`}>
                            <div className="content-box">
                                <div className="title" onClick={() => this.selectContent('sale_address_1')}>
                                    <div className="required">Sale Address 1</div>
                                    <div>
                                        <i className={`fa ${this.state.active_tag === 'sale_address_1' ? 'fa-chevron-down' : 'fa-chevron-right'}`}></i>
                                    </div>
                                </div>
                                <div className="expand">
                                    <h5>Sale Address 1</h5>
                                    <div>Sale title is just for idenify which type of sale this.</div>
                                </div>
                            </div>
                        </div>
                        <div ref={(el) => this[`sale_address_2`] = el} className={`${this.state.active_tag === 'sale_address_2' ? 'active-tag' : ''}`}>
                            <div className="content-box">
                                <div className="title" onClick={() => this.selectContent('sale_address_2')}>
                                    <div className="required">Sale Address 2</div>
                                    <div>
                                        <i className={`fa ${this.state.active_tag === 'sale_address_2' ? 'fa-chevron-down' : 'fa-chevron-right'}`}></i>
                                    </div>
                                </div>
                                <div className="expand">
                                    <h5>Sale Address 2</h5>
                                    <div>Sale title is just for idenify which type of sale this.</div>
                                </div>
                            </div>
                        </div>
                        <div ref={(el) => this[`zip_code_for_sale`] = el} className={`${this.state.active_tag === 'zip_code_for_sale' ? 'active-tag' : ''}`}>
                            <div className="content-box">
                                <div className="title" onClick={() => this.selectContent('zip_code_for_sale')}>
                                    <div className="required">Zip</div>
                                    <div>
                                        <i className={`fa ${this.state.active_tag === 'zip_code_for_sale' ? 'fa-chevron-down' : 'fa-chevron-right'}`}></i>
                                    </div>
                                </div>
                                <div className="expand">
                                    <h5>Zip</h5>
                                    <div>Contact Name is the name of the contact who handles the sale for a location.</div>
                                </div>
                            </div>
                        </div>
                        <div ref={(el) => this[`city_for_sale`] = el} className={`${this.state.active_tag === 'city_for_sale' ? 'active-tag' : ''}`}>
                            <div className="content-box">
                                <div className="title" onClick={() => this.selectContent('city_for_sale')}>
                                    <div className="required">City</div>
                                    <div>
                                        <i className={`fa ${this.state.active_tag === 'city_for_sale' ? 'fa-chevron-down' : 'fa-chevron-right'}`}></i>
                                    </div>
                                </div>
                                <div className="expand">
                                    <h5>City</h5>
                                    <div>Contact Name is the name of the contact who handles the sale for a location.</div>
                                </div>
                            </div>
                        </div>
                        <div ref={(el) => this[`client_name`] = el} className={`${this.state.active_tag === 'client_name' ? 'active-tag' : ''}`}>
                            <div className="content-box">
                                <div className="title" onClick={() => this.selectContent('client_name')}>
                                    <div className="required">Client name</div>
                                    <div>
                                        <i className={`fa ${this.state.active_tag === 'client_name' ? 'fa-chevron-down' : 'fa-chevron-right'}`}></i>
                                    </div>
                                </div>
                                <div className="expand">
                                    <h5>Client name</h5>
                                    <div>Client Name is the name of the contact who handles the sale for a location.</div>
                                </div>
                            </div>
                        </div>
                        <div ref={(el) => this[`start_date_and_time`] = el} className={`${this.state.active_tag === 'start_date_and_time' ? 'active-tag' : ''}`}>
                            <div className="content-box">
                                <div className="title" onClick={() => this.selectContent('start_date_and_time')}>
                                    <div className="required">Start Date and time</div>
                                    <div>
                                        <i className={`fa ${this.state.active_tag === 'start_date_and_time' ? 'fa-chevron-down' : 'fa-chevron-right'}`}></i>
                                    </div>
                                </div>
                                <div className="expand">
                                    <h5>Start Date and time</h5>
                                    <div>Sale Start date and time will be based on the lcoation timezone of this sale.</div>
                                </div>
                            </div>
                        </div>
                        <div ref={(el) => this[`end_date_and_time`] = el} className={`${this.state.active_tag === 'end_date_and_time' ? 'active-tag' : ''}`}>
                            <div className="content-box">
                                <div className="title" onClick={() => this.selectContent('end_date_and_time')}>
                                    <div className="required">End Date and time</div>
                                    <div>
                                        <i className={`fa ${this.state.active_tag === 'end_date_and_time' ? 'fa-chevron-down' : 'fa-chevron-right'}`}></i>
                                    </div>
                                </div>
                                <div className="expand">
                                    <h5>End Date and time</h5>
                                    <div>End Start date and time will be based on the lcoation timezone of this sale.</div>
                                </div>
                            </div>
                        </div>
                        <div ref={(el) => this[`close_duration`] = el} className={`${this.state.active_tag === 'close_duration' ? 'active-tag' : ''}`}>
                            <div className="content-box">
                                <div className="title" onClick={() => this.selectContent('close_duration')}>
                                    <div className="required">Close Duratione</div>
                                    <div>
                                        <i className={`fa ${this.state.active_tag === 'close_duration' ? 'fa-chevron-down' : 'fa-chevron-right'}`}></i>
                                    </div>
                                </div>
                                <div className="expand">
                                    <h5>Close Duration</h5>
                                    <div>End Start date and time will be based on the lcoation timezone of this sale.</div>
                                </div>
                            </div>
                        </div>
                        <div ref={(el) => this[`tax`] = el} className={`${this.state.active_tag === 'tax' ? 'active-tag' : ''}`}>
                            <div className="content-box">
                                <div className="title" onClick={() => this.selectContent('tax')}>
                                    <div className="required">Tax</div>
                                    <div>
                                        <i className={`fa ${this.state.active_tag === 'tax' ? 'fa-chevron-down' : 'fa-chevron-right'}`}></i>
                                    </div>
                                </div>
                                <div className="expand">
                                    <h5>Tax</h5>
                                    <div>Sale Tax will be applied for an item sold.</div>
                                </div>
                            </div>
                        </div>
                        <div ref={(el) => this[`buyer_premium`] = el} className={`${this.state.active_tag === 'buyer_premium' ? 'active-tag' : ''}`}>
                            <div className="content-box">
                                <div className="title" onClick={() => this.selectContent('buyer_premium')}>
                                    <div className="required">Buyer Premium</div>
                                    <div>
                                        <i className={`fa ${this.state.active_tag === 'buyer_premium' ? 'fa-chevron-down' : 'fa-chevron-right'}`}></i>
                                    </div>
                                </div>
                                <div className="expand">
                                    <h5>Buyer Premium</h5>
                                    <div>Contact Name is the name of the contact who handles the sale for a location.</div>
                                </div>
                            </div>
                        </div>
                        <div ref={(el) => this[`sale_provenance`] = el} className={`${this.state.active_tag === 'sale_provenance' ? 'active-tag' : ''}`}>
                            <div className="content-box">
                                <div className="title" onClick={() => this.selectContent('sale_provenance')}>
                                    <div className="required">Sale Provenance</div>
                                    <div>
                                        <i className={`fa ${this.state.active_tag === 'sale_provenance' ? 'fa-chevron-down' : 'fa-chevron-right'}`}></i>
                                    </div>
                                </div>
                                <div className="expand">
                                    <h5>Sale Provenance</h5>
                                    <div>Contact Name is the name of the contact who handles the sale for a location.</div>
                                </div>
                            </div>
                        </div>
                        <div ref={(el) => this[`category_for_item`] = el} className={`${this.state.active_tag === 'category_for_item' ? 'active-tag' : ''}`}>
                            <div className="content-box">
                                <div className="title" onClick={() => this.selectContent('category_for_item')}>
                                    <div className="required">Category</div>
                                    <div>
                                        <i className={`fa ${this.state.active_tag === 'category_for_item' ? 'fa-chevron-down' : 'fa-chevron-right'}`}></i>
                                    </div>
                                </div>
                                <div className="expand">
                                    <h5>Category</h5>
                                    <div>Contact Name is the name of the contact who handles the sale for a location.</div>
                                </div>
                            </div>
                        </div>
                        <div ref={(el) => this[`area`] = el} className={`${this.state.active_tag === 'area' ? 'active-tag' : ''}`}>
                            <div className="content-box">
                                <div className="title" onClick={() => this.selectContent('area')}>
                                    <div className="required">Area</div>
                                    <div>
                                        <i className={`fa ${this.state.active_tag === 'area' ? 'fa-chevron-down' : 'fa-chevron-right'}`}></i>
                                    </div>
                                </div>
                                <div className="expand">
                                    <h5>Area</h5>
                                    <div>Contact Name is the name of the contact who handles the sale for a location.</div>
                                </div>
                            </div>
                        </div>
                        <div ref={(el) => this[`item_title`] = el} className={`${this.state.active_tag === 'item_title' ? 'active-tag' : ''}`}>
                            <div className="content-box">
                                <div className="title" onClick={() => this.selectContent('item_title')}>
                                    <div className="required">Title</div>
                                    <div>
                                        <i className={`fa ${this.state.active_tag === 'item_title' ? 'fa-chevron-down' : 'fa-chevron-right'}`}></i>
                                    </div>
                                </div>
                                <div className="expand">
                                    <h5>Title</h5>
                                    <div>Contact Name is the name of the contact who handles the sale for a location.</div>
                                </div>
                            </div>
                        </div>
                        <div ref={(el) => this[`Lot_SKU`] = el} className={`${this.state.active_tag === 'Lot_SKU' ? 'active-tag' : ''}`}>
                            <div className="content-box">
                                <div className="title" onClick={() => this.selectContent('Lot_SKU')}>
                                    <div className="required">Lot #(SKU)</div>
                                    <div>
                                        <i className={`fa ${this.state.active_tag === 'Lot_SKU' ? 'fa-chevron-down' : 'fa-chevron-right'}`}></i>
                                    </div>
                                </div>
                                <div className="expand">
                                    <h5>Lot #(SKU)</h5>
                                    <div>Contact Name is the name of the contact who handles the sale for a location.</div>
                                </div>
                            </div>
                        </div>
                        <div ref={(el) => this[`condition`] = el} className={`${this.state.active_tag === 'condition' ? 'active-tag' : ''}`}>
                            <div className="content-box">
                                <div className="title" onClick={() => this.selectContent('condition')}>
                                    <div className="required">Condition</div>
                                    <div>
                                        <i className={`fa ${this.state.active_tag === 'condition' ? 'fa-chevron-down' : 'fa-chevron-right'}`}></i>
                                    </div>
                                </div>
                                <div className="expand">
                                    <h5>Condition</h5>
                                    <div>Contact Name is the name of the contact who handles the sale for a location.</div>
                                </div>
                            </div>
                        </div>
                        <div ref={(el) => this[`items_status`] = el} className={`${this.state.active_tag === 'items_status' ? 'active-tag' : ''}`}>
                            <div className="content-box">
                                <div className="title" onClick={() => this.selectContent('items_status')}>
                                    <div className="required">Status</div>
                                    <div>
                                        <i className={`fa ${this.state.active_tag === 'items_status' ? 'fa-chevron-down' : 'fa-chevron-right'}`}></i>
                                    </div>
                                </div>
                                <div className="expand">
                                    <h5>Status</h5>
                                    <div>Contact Name is the name of the contact who handles the sale for a location.</div>
                                </div>
                            </div>
                        </div>
                        <div ref={(el) => this[`item_type`] = el} className={`${this.state.active_tag === 'item_type' ? 'active-tag' : ''}`}>
                            <div className="content-box">
                                <div className="title" onClick={() => this.selectContent('item_type')}>
                                    <div className="required">Item Type</div>
                                    <div>
                                        <i className={`fa ${this.state.active_tag === 'item_type' ? 'fa-chevron-down' : 'fa-chevron-right'}`}></i>
                                    </div>
                                </div>
                                <div className="expand">
                                    <h5>Item Type</h5>
                                    <div>Contact Name is the name of the contact who handles the sale for a location.</div>
                                </div>
                            </div>
                        </div>
                        <div ref={(el) => this[`starting_price`] = el} className={`${this.state.active_tag === 'starting_price' ? 'active-tag' : ''}`}>
                            <div className="content-box">
                                <div className="title" onClick={() => this.selectContent('starting_price')}>
                                    <div>Starting Price</div>
                                    <div>
                                        <i className={`fa ${this.state.active_tag === 'starting_price' ? 'fa-chevron-down' : 'fa-chevron-right'}`}></i>
                                    </div>
                                </div>
                                <div className="expand">
                                    <h5>Starting Price</h5>
                                    <div>Contact Name is the name of the contact who handles the sale for a location.</div>
                                </div>
                            </div>
                        </div>
                        <div ref={(el) => this[`reserve_price`] = el} className={`${this.state.active_tag === 'reserve_price' ? 'active-tag' : ''}`}>
                            <div className="content-box">
                                <div className="title" onClick={() => this.selectContent('reserve_price')}>
                                    <div>Reserve Price</div>
                                    <div>
                                        <i className={`fa ${this.state.active_tag === 'reserve_price' ? 'fa-chevron-down' : 'fa-chevron-right'}`}></i>
                                    </div>
                                </div>
                                <div className="expand">
                                    <h5>Reserve Price</h5>
                                    <div>Contact Name is the name of the contact who handles the sale for a location.</div>
                                </div>
                            </div>
                        </div>
                        <div ref={(el) => this[`buy_it_now_price`] = el} className={`${this.state.active_tag === 'buy_it_now_price' ? 'active-tag' : ''}`}>
                            <div className="content-box">
                                <div className="title" onClick={() => this.selectContent('buy_it_now_price')}>
                                    <div className="required">Buy it now price</div>
                                    <div>
                                        <i className={`fa ${this.state.active_tag === 'buy_it_now_price' ? 'fa-chevron-down' : 'fa-chevron-right'}`}></i>
                                    </div>
                                </div>
                                <div className="expand">
                                    <h5>Buy it now price</h5>
                                    <div>Contact Name is the name of the contact who handles the sale for a location.</div>
                                </div>
                            </div>
                        </div>
                        <div ref={(el) => this[`Shipping`] = el} className={`${this.state.active_tag === 'Shipping' ? 'active-tag' : ''}`}>
                            <div className="content-box">
                                <div className="title" onClick={() => this.selectContent('Shipping')}>
                                    <div>Shipping</div>
                                    <div>
                                        <i className={`fa ${this.state.active_tag === 'Shipping' ? 'fa-chevron-down' : 'fa-chevron-right'}`}></i>
                                    </div>
                                </div>
                                <div className="expand">
                                    <h5>Shipping</h5>
                                    <div>Contact Name is the name of the contact who handles the sale for a location.</div>
                                </div>
                            </div>
                        </div>
                        <div ref={(el) => this[`Handling`] = el} className={`${this.state.active_tag === 'Handling' ? 'active-tag' : ''}`}>
                            <div className="content-box">
                                <div className="title" onClick={() => this.selectContent('Handling')}>
                                    <div>Handling</div>
                                    <div>
                                        <i className={`fa ${this.state.active_tag === 'Handling' ? 'fa-chevron-down' : 'fa-chevron-right'}`}></i>
                                    </div>
                                </div>
                                <div className="expand">
                                    <h5>Handling</h5>
                                    <div>Contact Name is the name of the contact who handles the sale for a location.</div>
                                </div>
                            </div>
                        </div>
                        <div ref={(el) => this[`Goal`] = el} className={`${this.state.active_tag === 'Goal' ? 'active-tag' : ''}`}>
                            <div className="content-box">
                                <div className="title" onClick={() => this.selectContent('Goal')}>
                                    <div>Goal</div>
                                    <div>
                                        <i className={`fa ${this.state.active_tag === 'Goal' ? 'fa-chevron-down' : 'fa-chevron-right'}`}></i>
                                    </div>
                                </div>
                                <div className="expand">
                                    <h5>Goal</h5>
                                    <div>Contact Name is the name of the contact who handles the sale for a location.</div>
                                </div>
                            </div>
                        </div>
                        <div ref={(el) => this[`Valuation`] = el} className={`${this.state.active_tag === 'Valuation' ? 'active-tag' : ''}`}>
                            <div className="content-box">
                                <div className="title" onClick={() => this.selectContent('Valuation')}>
                                    <div>Valuation</div>
                                    <div>
                                        <i className={`fa ${this.state.active_tag === 'Valuation' ? 'fa-chevron-down' : 'fa-chevron-right'}`}></i>
                                    </div>
                                </div>
                                <div className="expand">
                                    <h5>Valuation</h5>
                                    <div>Contact Name is the name of the contact who handles the sale for a location.</div>
                                </div>
                            </div>
                        </div>
                        <div ref={(el) => this[`Tag`] = el} className={`${this.state.active_tag === 'Tag' ? 'active-tag' : ''}`}>
                            <div className="content-box">
                                <div className="title" onClick={() => this.selectContent('Tag')}>
                                    <div>Tag</div>
                                    <div>
                                        <i className={`fa ${this.state.active_tag === 'Tag' ? 'fa-chevron-down' : 'fa-chevron-right'}`}></i>
                                    </div>
                                </div>
                                <div className="expand">
                                    <h5>Tag</h5>
                                    <div>Contact Name is the name of the contact who handles the sale for a location.</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <Button variant="secondary" className="close-button" size="sm" onClick={this.onCloseEvent}>Close</Button>
                </div>
            </div>
        );
    }
}
